
import { all, takeLatest, takeEvery } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../resources/constants";
import * as UserSaga from './user'
import * as BankTrans from './bankTrans'
import * as chartAccount from './chartAccount'
import * as glClassification from './glClassification'
import * as glBankFeed from './glBankFeed'
import * as glViewRegister from './glViewRegister'
import * as ReportSaga from './report'
import * as FourThreeThree from './fourThreeThreeB'
import * as Settings from './settings'
import * as Budget from './budget'
import * as CreditCard from './creditCard'
import * as QuickBook from './quickBook'
import * as Gusto from './gusto'


export default function* rootSaga() {
    yield all([
        // takeLatest(SAGA_ACTIONS.USER.LOGIN, UserSaga.login),
        takeLatest(SAGA_ACTIONS.USER.DETAILS, UserSaga.me),
        takeEvery(SAGA_ACTIONS.TRANSACTION.TRANS_LIST, BankTrans.bankTrans),
        takeLatest(SAGA_ACTIONS.TRANSACTION.CREATE_TRANSACTION_ADJUSTMENT, BankTrans.createAdjustment),
        takeLatest(SAGA_ACTIONS.TRANSACTION.DISCARD_TRANSACTION, BankTrans.discardTransaction),
        takeLatest(SAGA_ACTIONS.USER.USER_ACCESS, UserSaga.user_access),
        // takeLatest(SAGA_ACTIONS.USER.ACCOUNT_ALLOWANCE, UserSaga.user_allowance),
        // takeLatest(SAGA_ACTIONS.USER.USER_STEP_STATUS, UserSaga.user_step_status),
        // takeEvery(SAGA_ACTIONS.USER.USER_STEP_STATUS, UserSaga.user_step_status),

        takeEvery(SAGA_ACTIONS.CHART_ACCOUNT.LIST, chartAccount.list),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.DETAILS, chartAccount.accountDetails),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.CREATE, chartAccount.create),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.UPDATE, chartAccount.update),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.AVAILABLE_ACCOUNT, chartAccount.availableAccounts),
        takeEvery(SAGA_ACTIONS.CHART_ACCOUNT.GL_ACCOUNT_LIST, chartAccount.gl_account_list),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.LIST_TREE, chartAccount.list_tree),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.ACCOUNT_LEBEL, chartAccount.lebel),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.BANK_SALE_LIST, chartAccount.bankAccountList),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.BANK_SALE_UPDATE, chartAccount.bankAccountUpdate),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.FETCH_OPENNING_BALANCE, chartAccount.fetchOpenningAcc),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.POST_OPENNING_BALANCE, chartAccount.postOpenningAcc),

        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_TRANS_LIST, glClassification.list),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_RECONCILE_TRANS_LIST, glClassification.reconcileTxnList),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_RECONCILE_OPENNING_BALANCE_FETCH, glClassification.reconcileOpenningBalanceFetch),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_RECONCILE_TRANS_POST, glClassification.reconcilePost),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_SALES_LIST, glClassification.saleList),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.BANK_GL_UPDATE, glClassification.bankGlUpdate),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.SALE_GL_UPDATE, glClassification.saleGlUpdate),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.REVENUE_GL_UPDATE, glClassification.revenueGlUpdate),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.CLASSIFICATION_STATUS, glClassification.classificationStatus),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.COMPLETE_STEP, glClassification.completeStatus),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.SKIP_BEGINNING_BALANCE, glClassification.skipBeginningBalance),

        takeLatest(SAGA_ACTIONS.BANK_FEED.FETCH_LIST, glBankFeed.list),
        takeLatest(SAGA_ACTIONS.BANK_FEED.UPDATE, glBankFeed.feedUpdate),
        takeLatest(SAGA_ACTIONS.BANK_FEED.FETCH_BANK_TEMPLATES, glBankFeed.fetchBankTemplates),
        takeLatest(SAGA_ACTIONS.BANK_FEED.ADD_BANK_ACCOUNT, glBankFeed.addBankAccount),

        takeLatest(SAGA_ACTIONS.VIEW_REGISTER.FETCH_LIST, glViewRegister.list),
        takeLatest(SAGA_ACTIONS.VIEW_REGISTER.EXPORT_CSV, glViewRegister.exportTransactionsCsv),

        takeLatest(SAGA_ACTIONS.REPORT.BALANCE_SHEET, ReportSaga.balanceSheet),
        takeLatest(SAGA_ACTIONS.REPORT.REFRESH_BALANCE_SHEET, ReportSaga.balanceSheetRefresh),
        takeLatest(SAGA_ACTIONS.REPORT.REPORT_DOWNLOAD_BS, ReportSaga.reportDownload),
        takeLatest(SAGA_ACTIONS.REPORT.REPORT_DOWNLOAD_BT, ReportSaga.reportDownloadBT),
        takeLatest(SAGA_ACTIONS.REPORT.PROFIT_LOSSS, ReportSaga.profitLoss),
        takeLatest(SAGA_ACTIONS.REPORT.STATEMENT_OF_CASH_FLOW, ReportSaga.cashFlow),
        takeLatest(SAGA_ACTIONS.REPORT.DASHBOARD_RATIO, ReportSaga.dashboardRatio),
        takeLatest(SAGA_ACTIONS.REPORT.TXN_REGISTER_PL, ReportSaga.txnRegisterPL),

        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.DETAILS, FourThreeThree.getData),
        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.CREATE, FourThreeThree.create),
        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.UPDATE, FourThreeThree.update),
        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.MONTHLY_EXPENSE, FourThreeThree.getIncome),
        takeLatest(SAGA_ACTIONS.PERSONAL_BALANCE_SHEET.CREATE, FourThreeThree.createBS),
        takeLatest(SAGA_ACTIONS.PERSONAL_BALANCE_SHEET.DETAILS, FourThreeThree.fetchBS),
        takeLatest(SAGA_ACTIONS.PERSONAL_INCOME_STATMENT.CREATE, FourThreeThree.createPI),
        takeLatest(SAGA_ACTIONS.PERSONAL_INCOME_STATMENT.DETAILS, FourThreeThree.fetchPI),

        // takeLatest(SAGA_ACTIONS.SETTINGS.FETCH_DETAILS, Settings.fetchSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.UPDATE_ACCOUNTING, Settings.updateAccountingSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.UPDATE_SALES, Settings.updateSalesSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.FETCH_ACCOUNT_DETAILS, Settings.fetchAccountSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.UPGRADE_TO_LATEST_GL, Settings.updateTolatestGl),

        takeLatest(SAGA_ACTIONS.BUDGET.FETCH_DETAILS, Budget.fetchBudget),
        takeLatest(SAGA_ACTIONS.BUDGET.ADD, Budget.addBudget),
        takeLatest(SAGA_ACTIONS.BUDGET.UPDATE, Budget.updateBudget),
        takeLatest(SAGA_ACTIONS.BUDGET.PUBLISH, Budget.publishBudget),

        takeLatest(SAGA_ACTIONS.CREDIT_CARD.FETCH_LIST, CreditCard.listCreditCardCsvRecords),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.FETCH_DETAILS, CreditCard.fetchCreditCardCsvRecord),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.UPLOAD_CSV, CreditCard.uploadCreditCardCsv),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.CC_UPLOAD, CreditCard.creditCardUpload),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.CC_DELETE, CreditCard.deleteCreditCardCsv),

        takeLatest(SAGA_ACTIONS.QUICK_BOOK.AUTH, QuickBook.auth),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.CALLBACK, QuickBook.callback),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.IMPORT_DATA, QuickBook.importDate),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.FETCH_ACCOUNT_CHARTS, QuickBook.fetchAccountChart),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.POST_ACCOUNT_CHARTS, QuickBook.postAccountChart),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_OPENNING_BALANCE, QuickBook.qbFetchOpenningAcc),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_POST_OPENNING_BALANCE, QuickBook.qbPostOpenningAcc),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS_PL, QuickBook.qbFetchBSPL),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_POST_BS_PL, QuickBook.qbPostBSPL),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS, QuickBook.qbFetchBS),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_PL, QuickBook.qbFetchPL),

        takeLatest(SAGA_ACTIONS.GUSTO.FETCH_CLIENTID, Gusto.fetchClientId),
        takeLatest(SAGA_ACTIONS.GUSTO.CALLBACK, Gusto.callback),
        takeLatest(SAGA_ACTIONS.GUSTO.IMPORT_DATA, Gusto.importData),
        takeLatest(SAGA_ACTIONS.GUSTO.FETCH_EARNING_TYPES, Gusto.fetchEarningTypes),
        takeLatest(SAGA_ACTIONS.GUSTO.POST_EARNING_TYPES, Gusto.postEarningTypes),
        takeLatest(SAGA_ACTIONS.GUSTO.FETCH_PAYROLL_JOURNAL_LIST, Gusto.fetchPayrollJournalList),
        takeLatest(SAGA_ACTIONS.GUSTO.FETCH_PAYROLL_JOURNAL_DETAILS, Gusto.fetchPayrollJournalDetails),
        takeLatest(SAGA_ACTIONS.GUSTO.VERIFY_AND_SUBMIT_JOURNAL, Gusto.verifyAndSubmitJournal)
        
    ])
}